import React, { useEffect } from "react";
import "./StepperList.scss";
import PrimaryButton from "../Button/PrimaryButton/PrimaryButton";
import OutlineButton from "../Button/OutlineButton/OutlineButton";
import EventHandler from "../EventHandler";

interface IProps {
  stepperListData?: any;
  panelList?: any;
  className?: string;
  children?: any;
  StepperRef?: any;
  activeStepper?: any;
  SelectedVehiclesCount?: any;
  handleClickNext?: any;
  handleClickPrevious?: any;
  catalogItemDetailsLength?: number;
  handleAttachmentClick?: any;
  attachmentBtnClicked?: any;
  onCancelAttachment?: any;
  orderDetails?: any;
  btnBlockClassName?: any;
  nextBtnText?: any;
  disabled?: boolean;
  isPOCreated?: any;
  isComplete?: boolean;
  onClickReturnToHome?: Function;
  isButtonDisable?: any;
  isBulkOrder?: any;
  skipVendorDetail?: boolean;
  handleClickReturnToRequestor? : any;
  showReturnToRequestor?: boolean;
}

const StepperList = ({
  stepperListData = [],
  panelList = [],
  className = "",
  StepperRef,
  activeStepper,
  SelectedVehiclesCount,
  handleClickNext,
  handleClickPrevious,
  catalogItemDetailsLength,
  orderDetails,
  btnBlockClassName,
  nextBtnText,
  disabled,
  isPOCreated,
  isComplete = false,
  onClickReturnToHome,
  isButtonDisable,
  isBulkOrder,
  skipVendorDetail = false,
  handleClickReturnToRequestor,
  showReturnToRequestor = false
}: IProps) => {
  useEffect(() => {
    if (stepperListData.length > 0 && StepperRef !== null) {
      if (activeStepper === 2) {
        document
          .querySelector(".custom-stepper-list")
          ?.classList?.add("enable");
      } else {
        document
          .querySelector(".custom-stepper-list")
          ?.classList?.remove("enable");
      }
      StepperRef?.current?.children[activeStepper - 1]?.classList?.add("active");
      if (activeStepper > 1) {
        for (let i = 0; i <= activeStepper - 2; i++) {
          StepperRef?.current?.children[i].classList?.remove("active");
          StepperRef?.current?.children[i].classList?.add("completed");
        }
      }
    }
  }, [activeStepper, stepperListData]);
  return (
    <>
      <div className={`custom-stepper-list ${className}`} ref={StepperRef}>
        {stepperListData.map((item: any, index: any) => {
          return (
            <div
              className={`stepper-list ${
                stepperListData.length - 1 === index ? "last-stepper-list" : ""
              }`}
              id={`step_${item.step}`}
            >
                  <EventHandler onEvent={(e: any) => {
                      e.preventDefault();
                      item?.onClick(e);
                  }} data-attribute="index_Default_EventHandler_16">
                      <label className="toggle">
                          <input type="checkbox"  data-attribute="index_Default_Input_2" />
                          <span className="slider" data-on={item.step}></span>
                          <span
                              className="labels"
                              data-on={item.text}
                              data-off={item.text}
                          ></span>
                      </label>
                  </EventHandler>
            </div>
          );
        })}
        {panelList.map((item: any, index: any) => {
          return index === activeStepper - 1 && item.component;
        })}
        {
          <div className={`btn-block ${btnBlockClassName}`}>
            
            {catalogItemDetailsLength != 0 &&
              catalogItemDetailsLength != undefined && (<>
                              
                <PrimaryButton
                  // text="Continue Order"
                  text={nextBtnText}
                  disabled={
                    (SelectedVehiclesCount !== 0 &&
                      !disabled &&
                      !isPOCreated &&
                      !isBulkOrder) ||
                    !isButtonDisable
                      ? false
                      : true
                  }
                  className="pull-right next-btn"
                  onClick={() => handleClickNext()}
                 data-attribute="index_Default_Button_6"></PrimaryButton>
                {showReturnToRequestor && (
                  <OutlineButton
                    text="Return to Requestor"
                    onClick={handleClickReturnToRequestor}
                    className="ReturntoRequestor_CommonStepper"
                   data-attribute="index_Default_Button_7" />
                )}
             </>
 )}
            {activeStepper > 1 || isBulkOrder ? (
              <OutlineButton
                text={`${
                  isComplete && (skipVendorDetail || activeStepper === 4)
                    ? "Return Home"
                    : isBulkOrder
                    ? "Cancel"
                    : "Previous"
                }`}
                className="pull-right me-2 prev-btn"
                onClick={
                  isComplete && (skipVendorDetail || activeStepper === 4)
                    ? onClickReturnToHome
                    : handleClickPrevious
                }
                disabled={disabled}
               data-attribute="index_Default_Button_8"></OutlineButton>
            ) : null}
          </div>
        }
      </div>
    </>
  );
};

export default StepperList;
